module.exports = __webpack_public_path__ + "static/chair2-1eddb3514a7725a30b92cc57b3612783.jpg";